export default "__VITE_ASSET__CPkAEeib__"